import { sharedMonthlySource, sharedWeeklySource } from "../lib/rounds";
import { createTrendLoop } from "./trendLoop";
import { useSettingsStore } from "./settingsStore";

/**
 * The Predict trend Loops on the coarse timeframes (ADR-0013). Twins of the
 * daily trend Loop over the weekly and monthly banks, each with its own
 * persisted score and Streak: a weekly trend call and a daily one are
 * different skills, so they are scored apart the way the next-candle Loops
 * already are.
 */

export const usePredictWeeklyTrendStore = createTrendLoop({
  timeframe: "weekly",
  openSource: sharedWeeklySource,
  seenKey: "seen:weekly-trend",
  scoreKey: "predict-weekly-trend:score",
  streakKey: "predict-weekly-trend:streak",
});

export const usePredictMonthlyTrendStore = createTrendLoop({
  timeframe: "monthly",
  openSource: sharedMonthlySource,
  seenKey: "seen:monthly-trend",
  scoreKey: "predict-monthly-trend:score",
  streakKey: "predict-monthly-trend:streak",
});

// Same reason as the daily trend Loop: the barrier filter is preset-specific,
// so a mid-Round difficulty switch must re-check what is on screen (GRA-140).
useSettingsStore.subscribe((state, prevState) => {
  if (state.preset === prevState.preset) return;
  usePredictWeeklyTrendStore.getState().revalidate();
  usePredictMonthlyTrendStore.getState().revalidate();
});
